import {
  Box,
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FC, ReactNode, useEffect, useState } from "react";
import { v4 } from "uuid";
import { DVInlineProps } from "../DynamicVariableInline/types";
type TVariablePopup = Pick<
  DVInlineProps,
  "activeDynamicVariableId" | "setActiveDynamicVariableId" | "dynamicVariable"
> & {
  actions: ({ name: string } & Omit<ButtonProps, "children">)[];
  children?: ReactNode[];
  title?: string;
  onClose?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
  forceOpen?: boolean;
};

/**
 * Accepts 2 childrens only!
 *
 * - 1st child will be placed *outside* mui's dialog box
 *
 * - 2nd child will be placed *inside* mui's dialog content component
 *
 * @component
 */

const VariablePopup: FC<TVariablePopup> = ({
  actions,
  title,
  children,
  onClose,
  onCancel,
  onSave,
  dynamicVariable,
  activeDynamicVariableId,
  setActiveDynamicVariableId,
  forceOpen,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (forceOpen) {
      setOpen(forceOpen);
      return;
    } else {
      setOpen(false);
    }
    if (activeDynamicVariableId && dynamicVariable) {
      setOpen(activeDynamicVariableId === dynamicVariable._id);
    }
  }, [dynamicVariable, activeDynamicVariableId, forceOpen]);

  const handleOnDialogClose = () => {
    setActiveDynamicVariableId?.(undefined);
    onCancel?.();
    onClose?.();
  };

  return (
    <>
      {children?.[0]}
      <Dialog
        open={open}
        onClose={handleOnDialogClose}
        fullWidth
        maxWidth="sm"
      >
        {title ? <DialogTitle>{title}</DialogTitle> : null}
        <DialogContent sx={{ minWidth: 320, pt: "16px !important" }}>
          {children?.[1]}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
          <Box sx={{ flex: 1 }} />
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => {
              onCancel?.();
              handleOnDialogClose();
            }}
            sx={{
              borderColor: "#d0d0d0",
              color: "#666",
              "&:hover": {
                borderColor: "#999",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              onSave?.();
              handleOnDialogClose();
            }}
            sx={{
              backgroundColor: "#1a3a5c",
              "&:hover": {
                backgroundColor: "#2196f3",
              },
            }}
          >
            Save & Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VariablePopup;
